import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum BadgeModifier {
  CONTENT = 'content',
  CONTENT_ACTIVE = 'content-active',
  ALERT = 'alert',
  STATUS = 'status',
  HIGHLIGHT = 'highlight',
  INACTIVE = 'inactive',
  SMALL_FONT = 'small-font',
  PADDING_TOP_1 = 'padding-top-1',
  DARK = 'dark',
  SMALL = 'small',
}

type BadgeProps = PropsWithChildren<{
  title?: string;
  modifier?: Modifier<BadgeModifier>;
}>;

/**
 * Badge Component
 */
export function Badge({ title, modifier, children }: BadgeProps) {
  const classWithModifiers = () => {
    const base = bem('badge', modifier);
    if (Array.isArray(modifier) && modifier.includes(BadgeModifier.SMALL_FONT)) {
      return base + ' font-regular-13-13';
    }
    return base;
  };

  return (
    <span className={classWithModifiers()} title={title}>
      {children}
    </span>
  );
}
